namespace RioERP.Web.Enums {
    export enum CustomerType {
        B2B = 1,
        B2C = 2
    }
    Serenity.Decorators.registerEnumType(CustomerType, 'RioERP.Web.Enums.CustomerType');
}
